import { SocketWebService } from './services/socket-web.service';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { Router } from '@angular/router';
import { LocalStorageService, MenuBreadCrumb, ScreenSizeUtil } from 'brainloper-ui';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './services/authentication.service';
import { Notification } from "./models/notification/notification"
import { NotificationsService } from './services/notifications.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { EventService } from './services/event.service';
import { INotificationByCompany } from './models/maintenance/notification-by-company';
import { ThemeService, Theme } from './services/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('breadcrumbElement') breadcrumbElement: ElementRef;
  breadcrumbHeight: number = 0;
  mainRouterHeight: number = 90;


  public menuBreadCrumb: Array<MenuBreadCrumb> = [{
    name:"Inicio",
    router:'/inicio',
    current:true
  }]


  public nombreUsuario:string = '';
  public companyName:string = ''
  public logged:boolean = false
  public loading:boolean = false

  public activeSideBar : boolean = true;
  public isMobile : boolean = false;

  public size: number = screen.width
  public minimalScreen : number = environment.minimalScreen

  public notifications: Array<Notification> = []
  public subscriptionNotified:Subscription
  public subscriptionNotifiedByRol:Subscription
  public subscriptionNewVersion:Subscription
  public subscriptionLogoutByCompany:Subscription

  public extendedSideBar:boolean = true
  public availableThemes: Theme[] = [];
  public activeTheme: Theme;

  constructor(
    public router :Router,
    private storage : LocalStorageService,
    private authenticationService : AuthenticationService,
    private notificationServices : NotificationsService,
    private socketWebService : SocketWebService,
    public eventService: EventService,
    public themeService: ThemeService,
    private swUpdate: SwUpdate
  ){
    this.availableThemes = this.themeService.getAvailableThemes();
    this.themeService.activeTheme$.subscribe(theme => this.activeTheme = theme);
    
    //Detect new Service Worker versions and apply them transparently.
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      ).subscribe(() => {
        // Automatically reload the page to show the new version.
        window.location.reload();
      });
    }
  }

  async ngOnInit(){
    let initSession = this.storage.get<boolean>('initSession')

    if(initSession){
      this.loading = true
      const isValid = await this.authenticationService.getUserProfile({
        companyId: this.storage.get<number>('companyId'),
        user: this.storage.get<string>('user'),
      })
      if(!isValid){
        return
      }
      this.loading = false
    }
    
    this.nombreUsuario = this.storage.get<string>('userName')
    this.companyName = this.storage.get<string>('companyName')
    this.logged = true
    this.loading = false
    
    window.addEventListener('resize', () => {
      this.size = screen.width
      this.isMobile = ScreenSizeUtil.isMobile();
    })
    this.isMobile = ScreenSizeUtil.isMobile();
    this.updateNotification()
    this.lisenEventsSocket()     
  }

  changeTheme(theme: Theme) {
    this.themeService.setTheme(theme);
  }

  ngAfterViewInit() {
    // Defer height calculation to next microtask to avoid
    // ExpressionChangedAfterItHasBeenCheckedError on initial render
    Promise.resolve().then(() => this.setHeights());
  }

  private setHeights() {
    const header = document.getElementById('header');
    if (header) {
      const headerHeightPx = header.offsetHeight;
      const headerHeightVh = (headerHeightPx / window.innerHeight) * 100;
      this.mainRouterHeight = 100 - headerHeightVh;
  
      if (this.breadcrumbElement?.nativeElement) {
        this.breadcrumbHeight = this.breadcrumbElement.nativeElement.offsetHeight * 1.5;
      }

      document.documentElement.style.setProperty('--header-height-px', `${headerHeightPx}px`);
      document.documentElement.style.setProperty('--header-height-vh', `${headerHeightVh}vh`);
      document.documentElement.style.setProperty('--breadcrumb-height', `${this.breadcrumbHeight}px`);
      document.documentElement.style.setProperty('--content-height', `calc(100vh - ${headerHeightPx}px - ${this.breadcrumbHeight}px)`);
    }
  }


  private lisenEventsSocket(){
    this.subscriptionNewVersion = this.socketWebService.listen('new-version').subscribe( (res) => {
      if(res && this.storage.get<number>('roleId') != 1){
        this.cleanAndRefreshClient()
      }
    })
    this.subscriptionLogoutByCompany = this.socketWebService.listen('logout-by-company').subscribe( (res) => {
      if(res == this.storage.get<number>('id_compania') && this.storage.get<number>('roleId') != 1){
        this.authenticationService.Logout()
      }
    })
  }

  private cleanAndRefreshClient(){
    const form = document.createElement('form');
    form.method = "POST";
    form.action = location.href;
    document.body.appendChild(form);
    form.submit();
    this.authenticationService.Logout()
    window.location.reload()
  }

  ngAfterContentInit(){
    this.loading = false
  }

  async updateNotification(){
    this.subscriptionNotified = this.socketWebService.listen('notified').subscribe(async (data: INotificationByCompany) => {
      if(data.userId === this.storage.get('userId').toString() && data.companyId === this.storage.get('companyId').toString()){
        await this.getNotification()
      }
    })

    this.subscriptionNotifiedByRol = this.socketWebService.listen('notified-by-rol').subscribe(async (data: INotificationByCompany) => {
      if (data.roleId === this.storage.get('roleId').toString() && data.companyId === this.storage.get('companyId').toString()) {
        await this.getNotification()
      }
    })
    let c = this.storage.get('userId')
    if(this.notifications.length == 0 && c)
      await this.getNotification()
  }

  async getNotification(){
      this.notifications= await this.notificationServices.getNotifications()
  }

  getNameCompany(){
    this.companyName = this.storage.get<string>('companyName')
  }
  componentAdded($event){
    if($event.menuBreadCrumb) this.menuBreadCrumb = $event.menuBreadCrumb
    Object.keys($event).forEach(key=>{
      if(key=='loginForm'){
        this.logged=false
        this.loading=false
        this.nombreUsuario = ''
        this.companyName = ''
      }
    })
  }

  componentRemoved($event){
    Object.keys($event).forEach(key=>{
      if(key=='loginForm'){
        this.logged=true
        this.loading=false
        this.nombreUsuario = this.storage.get<string>('userName')
        this.companyName = this.storage.get<string>('companyName')
      }
    })

  }

  Logout(){
    this.authenticationService.Logout()
  }

  async redirect(data:Notification, $event){
    $event.preventDefault();
    await this.notificationServices.handlerNotification(data)
  }

  trackByNotificationId(index: number, notification: Notification): number {
    return notification.id || index;
  }

  handlerSideBarEvent(state:boolean){
    this.extendedSideBar = state
  }

ngOnDestroy(){
  this.subscriptionNotified.unsubscribe();
  this.subscriptionNotifiedByRol.unsubscribe();
  this.subscriptionNewVersion.unsubscribe();
  this.subscriptionLogoutByCompany.unsubscribe();
  }

  @HostListener('window:resize')
  onResize() {
    this.setHeights();
  }
}


